module.exports = __webpack_public_path__ + "8fa64cdb766a6c19b6ef3c8274106e76.svg";